// NEW: src/components/embedded-image-header.jsx
//
// Small header that embeds an image at the top of an existing sub-slide
// (priming question, concept-point, etc). Used when card.imageUrl is set
// AND the sub-slide has showImage=true. Renders nothing visible while the
// image loads, "Image not available" italic-grey on 404. Caller is
// responsible for deciding whether to render this at all.

import { useState, useEffect } from "react";
import { getFontFamily } from "../constants/colors";

export function EmbeddedImageHeader({ imageUrl, altText = "", lang }) {
  const ff = getFontFamily(lang);
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);
  // Reset on URL change so navigating between slides doesn't carry stale state.
  useEffect(() => { setLoaded(false); setErrored(false); }, [imageUrl]);

  if (!imageUrl) return null;

  return (
    <div style={{
      width: "100%",
      maxWidth: 520,
      margin: "0 auto 12px",
      padding: "0 20px",
      boxSizing: "border-box",
    }}>
      {errored ? (
        <div style={{
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 13,
          color: "#999999",
          fontStyle: "italic",
          fontFamily: ff,
          background: "#FFFFFF",
          border: "1px dashed #DDDDDD",
          borderRadius: 6,
          padding: "12px 16px",
        }}>
          Image not available
        </div>
      ) : (
        <div style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#FFFFFF",
          border: "1px solid #EEEEEE",
          borderRadius: 6,
          padding: 6,
          minHeight: loaded ? 0 : 60,
          boxSizing: "border-box",
        }}>
          <img
            src={imageUrl}
            alt={altText}
            onLoad={() => setLoaded(true)}
            onError={() => setErrored(true)}
            style={{
              maxWidth: "100%",
              maxHeight: "30vh",
              objectFit: "contain",
              display: loaded ? "block" : "none",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default EmbeddedImageHeader;
